import React, { useEffect, useRef } from "react";
import { Container, Grid, GridItem } from "../../../utils/CustomComponents";

// Grid Icons
import { FiEdit } from "react-icons/fi";
import { ReactComponent as HatMoney } from "../../../img/Section/HatMoney.svg";
import { ReactComponent as Investment } from "../../../img/Section/Investment.svg";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
function HowItWorks() {
    gsap.registerPlugin(ScrollTrigger);
    const grid = useRef();
    useEffect(() => {
        // Basic animation with Scroll trigger (when user scrols to something)
        const items_grid = gsap.utils.toArray(grid.current.children);
        items_grid.forEach((item_grid) => {
            gsap.from(item_grid, {
                scrollTrigger: item_grid,
                y: 100,
                opacity: 0,
                duration: 1,
                scale: 0.5,
                transformOrigin: "center center",
                ease: "power4.Out",
                stagger: { each: 0.5 },
            });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid.current]);
    return (
        <div id="how_it_works" className="grid_style">
            <Container>
                <h1 className="header">how it works</h1>
                <Grid gridRef={grid}>
                    <GridItem header="Create an account" icon={<FiEdit />}>
                        You can sign up as either a company or as a staff. You cannot be both.
                    </GridItem>
                    <GridItem header="Pension Payment" icon={<HatMoney />}>
                        Companies get to pay their registered staffs pension through the platform
                        and the companies get to decide when it can be withdrawn by the staff.
                    </GridItem>
                    <GridItem header="Crypto Investment" icon={<Investment />}>
                        Staffs can stake or invest their pension in crypto currencies since they
                        won’t be withdrawing their persion for some period of time.
                    </GridItem>
                </Grid>
            </Container>
        </div>
    );
}

export default HowItWorks;
